import { Badge, Button } from '@/components/UI';
import type { AuditPack } from './types';
import { badgeVariantForAuditGrade, labelForAuditProfile } from './helpers';

interface AuditSummaryBannerProps {
    activeAuditPack: AuditPack;
    onShowDetails: () => void;
}

const AuditSummaryBanner = ({ activeAuditPack, onShowDetails }: AuditSummaryBannerProps) => {
    return (
        <div className="border border-zinc-800 bg-zinc-950/60 rounded-lg px-3 py-2 mb-4">
            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-2">
                <div className="min-w-0">
                    <div className="flex flex-wrap items-center gap-2">
                        <span className="text-white text-sm font-semibold">Robust audit</span>
                        <Badge variant="secondary">{labelForAuditProfile(activeAuditPack.profile)}</Badge>
                        {activeAuditPack.bestCandidate && (
                            <Badge variant={badgeVariantForAuditGrade(activeAuditPack.bestCandidate.robustness.grade)}>
                                Best #{activeAuditPack.bestCandidate.rawRank}: {activeAuditPack.bestCandidate.robustness.score}{' '}
                                {activeAuditPack.bestCandidate.robustness.grade}
                            </Badge>
                        )}
                        <span className="text-zinc-500 text-xs">
                            {activeAuditPack.summary.candidatesAudited} audited · {activeAuditPack.summary.robustCandidateCount} strong+ ·
                            median {activeAuditPack.summary.medianScore ?? '-'}
                        </span>
                    </div>
                    {activeAuditPack.bestCandidate && (
                        <div className="text-zinc-400 text-xs mt-1 break-words">{activeAuditPack.bestCandidate.ruleSummary}</div>
                    )}
                </div>
                <div className="flex flex-wrap items-center gap-2">
                    <Button size="sm" variant="secondary" onClick={onShowDetails}>
                        Details
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default AuditSummaryBanner;
